var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorktype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 20.218,
    rx: 21,
    ry: 20.218,
    fill: "#E4FFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 12.768c-.828 0-1.5.66-1.5 1.473v12.768c0 .814.672 1.473 1.5 1.473h11c.828 0 1.5-.66 1.5-1.473v-8.72c0-.391-.158-.766-.44-1.042l-4.12-4.048a1.514 1.514 0 0 0-1.061-.431H15.5zm2.25 8.348c-.414 0-.75.33-.75.737 0 .406.336.736.75.736h6.5c.414 0 .75-.33.75-.736a.743.743 0 0 0-.75-.737h-6.5zm0 2.947c-.414 0-.75.33-.75.736 0 .407.336.737.75.737h6.5c.414 0 .75-.33.75-.737a.743.743 0 0 0-.75-.736h-6.5z",
    fill: "#027A48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorktype);
export default __webpack_public_path__ + "static/media/worktype.9a3278ea4f9be079779e489c79776ba6.svg";
export { ForwardRef as ReactComponent };